import React, { useEffect } from 'react'
import { Route, BrowserRouter as Router, Routes, useLocation } from 'react-router-dom'
import './App.css'
import Services from './Components/Services/Services'
import Solutions from './Components/Solutions/Solutions'
import Partners from './Components/Partners/Partners'
import Careers from './Components/Careers/Careers'
import Contact from './Components/Contact/Contact'
import Home from './Components/Home/Home'
import AboutUs from './Components/AboutUs/AboutUs'
import Footer from './Components/BasicBody/Footer'
import Navbar from './Components/BasicBody/ResponsiveNavbar/Navbar'
import DataCenter from './Components/Services/ICTinfrastructure/DataCenter'
import ServicePage from "./Components/ServicePage/ServicePage";
import IAssetMaxHome from "./Components/Services/AargusWeb/AssetMaxHome/AssetMaxHome";

const App = () => {
  // -----------------------Scroll to top when routing change---------------------
  const {pathname} = useLocation();
  
  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
  }, [pathname]);
  
  useEffect(() => {
    // Disable right-click context menu
    const handleContextMenu = (e) => {
      e.preventDefault();
    };
    
    // Disable keyboard shortcuts for inspect
    const handleKeyDown = (e) => {
      // Prevent F12 key
      if (e.keyCode === 123) {
        e.preventDefault();
      }
      
      // Prevent Ctrl+Shift+I (Chrome, Firefox, Safari)
      if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.key === 'I')) {
        e.preventDefault();
      }
      
      // Prevent Ctrl+Shift+C (Chrome)
      if (e.ctrlKey && e.shiftKey && (e.keyCode === 67 || e.key === 'C')) {
        e.preventDefault();
      }
      
      // Prevent Ctrl+Shift+J (Chrome)
      if (e.ctrlKey && e.shiftKey && (e.keyCode === 74 || e.key === 'J')) {
        e.preventDefault();
      }
      
      // Prevent Ctrl+U (View source)
      if (e.ctrlKey && (e.keyCode === 85 || e.key === 'U')) {
        e.preventDefault();
      }
    };
    
    // Add event listeners
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    
    // Clean up event listeners on component unmount
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  
  return (
    <>
      <Navbar/>
      <Routes>
        <Route path='/' element={<Home/>} />
        <Route path='/services' element={<Services/>} />
        <Route path='/Datacenter' element={<DataCenter/>} />
        <Route path='/solutions' element={<Solutions/>} />
        <Route path='/partners' element={<Partners/>} />
        <Route path='/careers' element={<Careers/>} />
        <Route path='/aboutus' element={<AboutUs/>} />
        <Route path='/contactus' element={<Contact/>} />
        <Route path="/services/:serviceCategory/:serviceType" element={<ServicePage />} />
        <Route path="/solutions/:serviceCategory/:serviceType" element={<ServicePage />} />
        <Route path="/iassetmax" element={<IAssetMaxHome />} />
        <Route path="/assetmax" element={<IAssetMaxHome />} />
      </Routes>
      <Footer/>
    </>
  )
}

export default App